export const isEmptyString = (val) => val !== null && typeof val === "string" && val.trim() === "";

export const convertToPhoneNumberFormat = (str) => {
    if (!str) return str;

    const digits = str.toString().replace(/\D/g, "");

    if (digits.length !== 10) {
        return str;
    }

    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const removeAccents = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};


// WEBPACK FOOTER //
// ./src/components/common/Helpers/StringHelper.js